"use client";

import {
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
  useState,
} from "react";
import { Suspense } from "react";

import { Modal } from "@/components/ui/modal";
import { UserAuthForm } from "@/components/forms/user-auth-form";

export type AuthModalMode = "login";

function SignInModal({
  showSignInModal,
  setShowSignInModal,
}: {
  showSignInModal: boolean;
  setShowSignInModal: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <Modal showModal={showSignInModal} setShowModal={setShowSignInModal}>
      <div className="w-full">
        <Suspense fallback={null}>
          <UserAuthForm onSuccess={() => setShowSignInModal(false)} />
        </Suspense>
      </div>
    </Modal>
  );
}

export function useSignInModal() {
  const [showSignInModal, setShowSignInModal] = useState(false);

  const openSignInModal = useCallback((open: boolean) => {
    setShowSignInModal(open);
  }, []);

  const SignInModalCallback = useCallback(() => {
    return (
      <SignInModal
        showSignInModal={showSignInModal}
        setShowSignInModal={setShowSignInModal}
      />
    );
  }, [showSignInModal, setShowSignInModal]);

  return useMemo(
    () => ({
      setShowSignInModal: openSignInModal,
      SignInModal: SignInModalCallback,
    }),
    [openSignInModal, SignInModalCallback],
  );
}
